import type { HttpClient } from '../http/HttpClient'
import type { BackgroundTask, BackgroundTaskKind, BackgroundTaskList, BackgroundTaskRepository, BackgroundTaskState } from '@/domain/backgroundTask/BackgroundTask'

interface RawBackgroundTask {
  task_id: string
  kind: BackgroundTaskKind
  state: BackgroundTaskState
  label: string
  progress_done: number | null
  progress_total: number | null
  summary: string
  messages_count: number
  error_message: string
  created_at: string
  started_at: string | null
  finished_at: string | null
}

interface RawBackgroundTaskList {
  active_count: number
  results: RawBackgroundTask[]
}

function toTask(raw: RawBackgroundTask): BackgroundTask {
  return {
    taskId: raw.task_id,
    kind: raw.kind,
    state: raw.state,
    label: raw.label,
    progressDone: raw.progress_done,
    progressTotal: raw.progress_total,
    summary: raw.summary,
    messagesCount: raw.messages_count,
    errorMessage: raw.error_message,
    createdAt: raw.created_at,
    startedAt: raw.started_at,
    finishedAt: raw.finished_at,
  }
}

export class HttpBackgroundTaskRepository implements BackgroundTaskRepository {
  constructor(private readonly http: HttpClient) {}

  async list(): Promise<BackgroundTaskList> {
    const raw = await this.http.url('background-tasks').get<RawBackgroundTaskList>()
    return { activeCount: raw.active_count, tasks: raw.results.map(toTask) }
  }

  async messages(taskId: string): Promise<string[]> {
    const raw = await this.http.url(`background-tasks/${encodeURIComponent(taskId)}`).get<{ messages: string[] }>()
    return raw.messages
  }
}
